/**
 * Created by administrator on 2017/3/29.
 */
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetSendGoodsForStock,
    GetSendGoodsStockList
} from '@api/sendGoodsApi';
import NProgress from 'nprogress';

export default {
    data() {
        return {
            Session: util.getSessin(),
            queryType: this.$store.state.OutboundStatus,
            queryDelivery: [{
                "TypeName": "-请选择-",
                "TypeValue": "-1"
            }, {
                "TypeName": "未发货",
                "TypeValue": "0"
            }, {
                "TypeName": "部分发货",
                "TypeValue": "1"
            }, {
                "TypeName": "全部发货",
                "TypeValue": "2"
            }],
            loading2: false,
            lists: [{
                "Id": "346567788"
            }],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            query: this.getQueryData()
        }
    },
    methods: {
        getQueryData() {
            return cloneDeep({
                OrderCode: "",
                SendCode: "",
                AgentName: "",
                AreaName: "",
                Status: "",
                DeliveryStatus: "",
                c_name: "",
                BusUser: ""
            });
        },
        //初始化加载页面
        List() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var para = this.getParams()
            GetSendGoodsStockList(para).then(res => {
                util.doResult(this, res, () => {});
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                for (var i = 0; i < Data.length; i++) {
                    Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
                    if (Data[i].AreaName == "北京北京市") {
                        Data[i].AreaName = "北京市"
                    }
                    if (Data[i].AreaName == "重庆重庆市") {
                        Data[i].AreaName = "重庆市"
                    }
                    if (Data[i].AreaName == "上海上海市") {
                        Data[i].AreaName = "上海市"
                    }
                    if (Data[i].AreaName == "天津天津市") {
                        Data[i].AreaName = "天津市"
                    }
                }
                this.outTips(StateCode, StateMsg, Data, Cnt)
            });
        },
        //通用输入参数
        getParams: function () {
            var para = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };

            for (let item in this.query) {
                let value = this.query[item];
                if (value !== '') {
                    // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                    if (typeof value == 'string') {
                        value = util.trimAllSpace(value);
                    }
                    this.query[item] = value
                    para[item] = value;
                }
            }

            return para;
        },
        //通用提示信息
        outTips: function (StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false; //拼命加载中隐藏
                this.lists = Data;
            }
        },

        selsChange: function (sels) {
            this.sels = sels;
        },
        //查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var para = this.getParams()
            this.List();
        }, //查询功能
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.List();
        },
        //查询单条
        handleView: function (index, row) {
            util.redirect(this, '/SendGoods/ViewSendGoodsForStock?Id=' + row.SendId, true);

        }, //生成出库单
        NewStockOut: function (index, row) {
            util.redirect(this, '/StockOut/AddStockOut?Id=' + row.SendId, true);
        }, //编辑功能
        onQueryClean: function () {
            this.query = this.getQueryData();
            this.List();
        },
        //删除
        handleDel: function () {
            var ids = this.sels.map(item => item.OrderId).toString();
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择删除内容',
                    type: 'warning'
                })
                return
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    NProgress.start();
                    let para = {
                        Ids: ids
                    };
                    ERP_OrderDel(para).then((response) => {
                        NProgress.done();
                        if (response.data.StateCode !== 0) {
                            this.$notify({
                                title: '错误',
                                message: response.data.StateMsg,
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success'
                            });
                            this.List();
                        }
                    });
                }).catch(() => {

                });

            }
        },

        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.List();
        }
    },
    watch: {
        '$route' (to, from) {
            if (this.$route.path == '/SendGoods/SendGoodsStorage') {
                this.List();
            }
        }
    },
    created() {
        this.List();
    }

}


// WEBPACK FOOTER //
// ./src/pages/storage/SendGoodsStorage/vm.js